import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ClinicExamField } from '../clinic-exam/clinic-exam.model';

/**
 * Auto Text picker for a field built in the Clinics exam builder (GUS-88).
 *
 * Same interaction and skin as the classic <app-autotext> popup, but the
 * snippets come from the template definition instead of /api/autotext: that
 * table (autocombined) is keyed by a hardcoded numeric DlgID and read back
 * WHERE UID = ?, so admin-authored snippets would never reach the doctors.
 */
@Component({
  selector: 'app-clinic-field-autotext',
  templateUrl: './clinic-field-autotext.component.html',
  styleUrls: ['./clinic-field-autotext.component.scss'],
  standalone: false
})
export class ClinicFieldAutotextComponent implements OnInit {
  @Input() field: ClinicExamField;
  @Input() control: AbstractControl;
  @Input() isHtml = false;
  @Output() closed = new EventEmitter<void>();

  Text = '';

  ngOnInit() {
    this.Text = this.htmlToText((this.control && this.control.value) || '');
  }

  addText(toadd: string) {
    const clean = this.htmlToText(toadd);
    if (this.Text && this.Text !== '') this.Text += '\n' + clean;
    else this.Text = clean;
  }

  save() {
    let text = this.Text;
    if (this.isHtml && text) {
      text = text.replace(/\n/g, '<br>');
    }
    if (this.control) this.control.setValue(text);
    this.close();
  }

  close() {
    this.closed.emit();
  }

  private htmlToText(html: string): string {
    if (!html) return '';
    html = html.replace(/<\/p>\s*<p[^>]*>/gi, '\n');
    html = html.replace(/<\/div>\s*<div[^>]*>/gi, '\n');
    html = html.replace(/<br\s*\/?>/gi, '\n');
    html = html.replace(/<\/?(?:p|div)[^>]*>/gi, '');
    html = html.replace(/<[^>]+>/g, '');
    html = html.replace(/&nbsp;/gi, ' ');
    html = html.replace(/&amp;/gi, '&');
    html = html.replace(/&lt;/gi, '<');
    html = html.replace(/&gt;/gi, '>');
    html = html.replace(/&#(\d+);/g, (_m, code) => String.fromCharCode(+code));
    html = html.replace(/&#x([0-9a-f]+);/gi, (_m, code) => String.fromCharCode(parseInt(code, 16)));
    return html.trim();
  }
}
